import React, { useState, useEffect, useMemo, useRef } from 'react'
import DashboardHeader from './components/DashboardHeader'
import DashboardCounts from './components/DashboardCounts'
import IncompleteCharting from './components/IncompleteCharting'
import ReviewCompletedOrders from './components/ReviewCompletedOrders'
import DeficientCharting from './components/DeficientCharting'
import MessagesTasks from './components/MessagesTasks'
import OverallVisitsFullscreen from './components/OverallVisitsFullscreen'
import DeficientChartingFullscreen from './components/DeficientChartingFullscreen'
import ReviewCompletedOrdersFullscreen from './components/ReviewCompletedOrdersFullscreen'
import MissingClaimNumbersFullScreen from '../EmployerDashboardNew/components/MissingClaimNumbersFullScreen'
import withReduxState from '../../hoc/wReduxState'
import WithRoutify from '../../hoc/WithRoutify'
import { acl_check } from '../../utils/aclUtils'
import PERMISSIONS from '../../utils/AclPermissions'

const Dashboard = (props) => {
  const [dateFilter, setDateFilter] = useState('year')
  const [visitsFullscreenOpen, setVisitsFullscreenOpen] = useState(false)
  const [deficientChartingOverlayOpen, setDeficientChartingOverlayOpen] = useState(false)
  const [reviewOrdersOverlayOpen, setReviewOrdersOverlayOpen] = useState(false)
  const [missingClaimNumbersFullscreenOpen, setMissingClaimNumbersFullscreenOpen] = useState(false)
  const [visitsInitialPosition, setVisitsInitialPosition] = useState(null)
  const [deficientChartingInitialPosition, setDeficientChartingInitialPosition] = useState(null)
  const [reviewOrdersInitialPosition, setReviewOrdersInitialPosition] = useState(null)
  const [missingClaimNumbersInitialPosition, setMissingClaimNumbersInitialPosition] = useState(null)
  const [dashboardCountsRefreshKey, setDashboardCountsRefreshKey] = useState(0)
  const globalFilter = props.globalFilter || {}
  const navigate = props.navigate
  const permissions = props?.profile?.permissions || {}
  const canViewIncompleteChartingTable = acl_check(permissions, PERMISSIONS.DASHBOARD.INCOMPLETE_CHARTING_TABLE)
  const canViewReviewCompletedOrdersTable = acl_check(permissions, PERMISSIONS.DASHBOARD.REVIEW_COMPLETED_ORDERS_TABLE)
  const canViewDeficientChartingTable = acl_check(permissions, PERMISSIONS.DASHBOARD.DEFICIENT_CHARTING_TABLE)
  const canViewMessagesTasksTable = acl_check(permissions, PERMISSIONS.DASHBOARD.MESSAGES_TASKS_TABLE)
  const canViewVisitCountsEyeIcon = acl_check(permissions, PERMISSIONS.DASHBOARD.OVER_ALL_VISITS)
  const canViewOrdersCountEyeIcon = canViewReviewCompletedOrdersTable

  // Extract filters from globalFilter if present
  // Dashboard uses Dashboard filter (as per getActiveMenuByPath in GlobalSearch)
  // Remove unwanted filters: visit_status, company_id, sample_id, clinic_id, cup_id, overall_result
  const dashboardFilters = useMemo(() => {
    const filters = globalFilter?.Dashboard || {}
    const {
      visit_status,
      company_id,
      sample_id,
      clinic_id,
      cup_id,
      overall_result,
      ...allowedFilters
    } = filters
    return allowedFilters
  }, [globalFilter])

  return (
    <>
    <div className="sh_mainPortview mb-0" id="sh_mainportal_view">
      <div className="sh_innerPortview">
        <div className="sh_cardBox sh_maincardht position-realtive">
          <DashboardHeader 
            dateFilter={dateFilter} 
            onDateFilterChange={setDateFilter}
            profile={props.profile}
          />
          {/* Card Body */}
          <div className="sh_cardBody sh_cardbglight pt-3 pb-4 px-4 overflow-auto">
            <DashboardCounts
              dateFilter={dateFilter}
              filters={dashboardFilters}
              countsRefreshKey={dashboardCountsRefreshKey}
              onVisitCountsClick={(rect) => { setVisitsInitialPosition(rect); setVisitsFullscreenOpen(true); }}
              onDeficientChartingClick={(rect) => { setDeficientChartingInitialPosition(rect); setDeficientChartingOverlayOpen(true); }}
              onReviewOrdersClick={(rect) => { setReviewOrdersInitialPosition(rect); setReviewOrdersOverlayOpen(true); }}
              onMissingClaimNumbersClick={(rect) => { setMissingClaimNumbersInitialPosition(rect); setMissingClaimNumbersFullscreenOpen(true) }}
              canViewVisitCountsEyeIcon={canViewVisitCountsEyeIcon}
              canViewOrdersCountEyeIcon={canViewOrdersCountEyeIcon}
              canViewDeficientChartingEyeIcon={canViewDeficientChartingTable}
            />
            <div className="row">
              {canViewIncompleteChartingTable && (
                <IncompleteCharting
                  dateFilter={dateFilter}
                  filters={dashboardFilters}
                  Loader={props.Loader}
                  Toast={props.Toast}
                  navigate={props.navigate}
                />
              )}
              {canViewReviewCompletedOrdersTable && (
                <ReviewCompletedOrders
                  dateFilter={dateFilter}
                  filters={dashboardFilters}
                  Loader={props.Loader}
                  Toast={props.Toast}
                />
              )}
            </div>
            <div className="row">
              {canViewDeficientChartingTable && (
                <DeficientCharting
                  dateFilter={dateFilter}
                  filters={dashboardFilters}
                  Loader={props.Loader}
                  Toast={props.Toast}
                  navigate={props.navigate}
                />
              )}
              {canViewMessagesTasksTable && <MessagesTasks />}
            </div>
            <OverallVisitsFullscreen
              isOpen={visitsFullscreenOpen}
              onClose={() => { setVisitsFullscreenOpen(false); setVisitsInitialPosition(null); }}
              initialPosition={visitsInitialPosition}
              dateFilter={dateFilter}
              filters={dashboardFilters}
              navigate={props.navigate}
            />
            <DeficientChartingFullscreen
              isOpen={deficientChartingOverlayOpen}
              onClose={() => { setDeficientChartingOverlayOpen(false); setDeficientChartingInitialPosition(null); }}
              initialPosition={deficientChartingInitialPosition}
              dateFilter={dateFilter}
              filters={dashboardFilters}
              navigate={props.navigate}
            />
            <ReviewCompletedOrdersFullscreen
              isOpen={reviewOrdersOverlayOpen}
              onClose={() => { setReviewOrdersOverlayOpen(false); setReviewOrdersInitialPosition(null); }}
              initialPosition={reviewOrdersInitialPosition}
              dateFilter={dateFilter}
              filters={dashboardFilters}
              Loader={props.Loader}
              Toast={props.Toast}
              navigate={props.navigate}
            />
          </div>
        </div>
      </div>
    </div>
    <MissingClaimNumbersFullScreen
      isOpen={missingClaimNumbersFullscreenOpen}
      onClose={() => { setMissingClaimNumbersFullscreenOpen(false); setMissingClaimNumbersInitialPosition(null) }}
      initialPosition={missingClaimNumbersInitialPosition}
      filters={dashboardFilters}
      Loader={props.Loader}
      Toast={props.Toast}
      onIncidentDeleted={() => setDashboardCountsRefreshKey((k) => k + 1)}
    />
    </>
  )
}

export default withReduxState(WithRoutify(Dashboard))
